// components/Layout.js

import { useEffect, useState } from "react";
import { useRouter } from "next/router"; // Import the useRouter hook

import React from "react";
import Progressbar from "../loading";

const Layout = ({ children }) => {
    const router = useRouter(); // Use the useRouter hook to get the router instance
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const startLoading = () => setLoading(true);
        const endLoading = () => setLoading(false);

        // Add event listeners for the `routeChangeStart` and `routeChangeComplete` events
        // These events will trigger when the user starts navigating and when the navigation is completed
        router.events.on("routeChangeStart", startLoading);
        router.events.on("routeChangeComplete", endLoading);
        router.events.on("routeChangeError", endLoading);

        return () => {
            router.events.off("routeChangeStart", startLoading);
            router.events.off("routeChangeComplete", endLoading);
            router.events.off("routeChangeError", endLoading);
        };
    }, []);

    return (
        <div>
            {loading ? (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        right: 0,
                        left: 0,
                        bottom: "0",
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(255, 255, 255, 0.5)",
                        zIndex: 9999,
                    }}
                >
                    <div className="flex items-center justify-center h-full relative z-9 max-w-2xl mx-auto">
                        <Progressbar size={100} />
                    </div>
                </div>
            ) : null}
            {children}
        </div>
    );
};

export default Layout;
